import {
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_BEGIN,
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_SUCCESS,
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_FAILURE,
  CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function customFunctionExecution(args = {}) {
  return (dispatch) => {
    dispatch({
      type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_BUILDER_ENGINE}custom-function/execute/${args.customFunctionId}`,
          args.payload,
          header,
        )
        .then(
          (res) => {
            if (res.status === 200 && res.data) {
              dispatch({
                type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_SUCCESS,
                data: res.data,
              });
              toast.success(`Function Executed Successfully`);
              resolve(res);
            } else {
              const errMsg = getErrorMessageFromResponse(res);
              dispatch({
                type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_FAILURE,
                // data: { error: errMsg },
                data: res.data,
              });
              toast.error(`Function Execution failed`);
              reject(errMsg);
            }
          },
          (err) => {
            const errMsg = getErrorMessageFromResponse(err.response || err);
            dispatch({
              type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_FAILURE,
              data: { error: errMsg },
            });
            toast.error(`Function Execution Failed`);
            reject(errMsg);
          },
        );
    });
    return promise;
  };
}

export function dismissCustomFunctionExecutionError() {
  return {
    type: CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_BEGIN:
      return {
        ...state,
        customFunctionExecutionPending: true,
        customFunctionExecutionError: null,
      };

    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_SUCCESS:
      return {
        ...state,
        customFunctionExecutionPending: false,
        customFunctionExecutionError: null,
        customFunctionExecutionResult: action.data,
      };

    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_FAILURE:
      return {
        ...state,
        customFunctionExecutionPending: false,
        customFunctionExecutionError: action.data.error,
      };

    case CUSTOM_COMPONENT_CUSTOM_FUNCTION_EXECUTION_DISMISS_ERROR:
      return {
        ...state,
        customFunctionExecutionError: null,
      };

    default:
      return state;
  }
}
